/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(Class) {

	const InteractionFactory = Class.extend({

		init: function(controller, logger) {
			InteractionFactory.inherited('init', this, arguments);

			this.controller = controller;
			this.logger = logger;
		},

		getInteraction: function(name) {
			const context = this._getContext();

			return this._getDelegate(name, context);
		},

		getInteractions: function(interactions) {
			return this._buildInteractions(interactions);
		},

		// Private

		_getContext: function() {
			return this.controller.layoutController;
		},

		_getConfigValue: function(name) {
			const interactions = this.controller.config.interactions;
			if (interactions) {
				return interactions[name];
			}
		},

		_buildInteractions: function(interactions) {
			const context = this._getContext();
			const enabledInteractions = {};
			let promise = Promise.resolve();

			for (let name in interactions) {
				if (interactions.hasOwnProperty(name)) {
					promise = promise
						.then(() => this._getDelegate(name, context))
						.then(delegate => {
							if (delegate) {
								const InteractionController = interactions[name];
								const interactionController = new InteractionController(this.controller);

								enabledInteractions[name] = new WrappedInteraction(interactionController, delegate);
							}
							return delegate;
						});
				}
			}

			return promise.then(() => enabledInteractions);
		},

		_getDelegate: function(name, context) {
			const value = this._getConfigValue(name);

			if (value === undefined || value === 'true' || value === true) {
				return Promise.resolve(new DefaultDelegate());
			} else if (value === 'false' || value === false) {
				return Promise.resolve();
			}

			return new Promise((resolve, reject) => {
				require([value], (Module) => {
					resolve(new Module(context));
				}, (error) => {
					reject(error);
				});
			}).catch((error) => {
				this.logger.warn(error);

				// If the module is not specified correctly, use the default behaviour.
				return new DefaultDelegate();
			});
		}

	});

	return InteractionFactory;
});

class WrappedInteraction {

	constructor(wrapped, delegate) {
		this.wrapped = wrapped;
		this.delegate = delegate;
	}

	newSelection() {
		if (this.delegate.isEnabled()) {
			this.wrapped && this.wrapped.newSelection.apply(this.wrapped, arguments);
		}
	}

	getProperties() {
		if (this.delegate.isEnabled() && this.wrapped && this.wrapped.getProperties) {
			return this.wrapped.getProperties.apply(this.wrapped, arguments);
		} else {
			return [];
		}
	}

}

class DefaultDelegate {

	isEnabled() {
		return true;
	}

}
